/// <reference path="../../generated/MitgliedschaftMitgliedschaftFamilienverbundApi.d.ts"/>

import { AppUtils } from '../../../utils/index';
import { MglArtApi } from "../../generated/PersonMglArtApi";
import { AdacIdentityModelApi } from "../../generated/ModelsAdacIdentityModelApi";


/**
 * The contract / rate information for a member.
 */
//TODO move to ../../view
export class ContractInfo {
	private alterBetrag: number;
	private geburtsdatumKinder: Array<string>;
	private geburtsdatumPartner: string;
	private inAusbildung: boolean;
	private schwerbehindert: boolean;
	private familienverbund: boolean;
	private plusMitglied: boolean;
	private premiumMitglied: boolean;
	private hatPartner: boolean;
	private beschreibung: string;
	private beitrag: number;
	private tarifCodeId: number;
	private tarifCode: string;
	private tarif: MglArtApi;

	get Tarif(): MglArtApi {
		return this.tarif;
	}

	set Tarif(value: MglArtApi) {
		this.tarif = value;
	}

	get TarifCode(): string {
		return this.tarifCode;
	}

	set TarifCode(value: string) {
		this.tarifCode = value;
	}

	get TarifCodeId(): number {
		return this.tarifCodeId;
	}

	set TarifCodeId(value: number) {
		this.tarifCodeId = value;
	}

	get Beitrag(): number {
		return this.beitrag;
	}

	set Beitrag(value: number) {
		this.beitrag = value;
	}

	get Beschreibung(): string {
		return this.beschreibung;
	}

	set Beschreibung(value: string) {
		this.beschreibung = value;
	}

	get HatPartner(): boolean {
		return this.hatPartner;
	}

	set HatPartner(value: boolean) {
		this.hatPartner = value;
	}

	get PlusMitglied(): boolean {
		return this.plusMitglied;
	}

	set PlusMitglied(value: boolean) {
		this.plusMitglied = value;
	}

	get PremiumMitglied(): boolean {
		return this.premiumMitglied;
	}

	set PremiumMitglied(value: boolean) {
		this.premiumMitglied = value;
	}

	get Familienverbund(): boolean {
		return this.familienverbund;
	}

	set Familienverbund(value: boolean) {
		this.familienverbund = value;
	}
	get Schwerbehindert(): boolean {
		return this.schwerbehindert;
	}

	set Schwerbehindert(value: boolean) {
		this.schwerbehindert = value;
	}

	get InAusbildung(): boolean {
		return this.inAusbildung;
	}

	set InAusbildung(value: boolean) {
		this.inAusbildung = value;
	}

	get GeburtsdatumPartner(): string {
		return this.geburtsdatumPartner;
	}

	set GeburtsdatumPartner(value: string) {
		this.geburtsdatumPartner = value;
	}

	get GeburtsdatumKinder(): Array<string> {
		return this.geburtsdatumKinder;
	}

	set GeburtsdatumKinder(value: Array<string>) {
		this.geburtsdatumKinder = value;
	}

	get AlterBetrag(): number {
		return this.alterBetrag;
	}

	set AlterBetrag(value: number) {
		this.alterBetrag = value;
	}

	public getDesicription(mappings: { [key: string]: string }): string {
		return ContractInfo.getDescription(mappings, this.TarifCodeId);
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	public mergeWithUser(user: AdacIdentityModelApi): void {
		this.tarif = user.UserData.Mitgliedschaft.TarifInformation.Tarif;
		this.tarifCode = user.UserData.Mitgliedschaft.TarifInformation.TarifCode;
		this.schwerbehindert = user.UserData.Mitgliedschaft.TarifInformation.Schwerbehindert;
		this.inAusbildung = user.UserData.Mitgliedschaft.TarifInformation.InAusbildung;
		this.beitrag = user.UserData.Mitgliedschaft.TarifInformation.Beitrag;
		this.familienverbund = user.UserData.Mitgliedschaft.TarifInformation.Familienverbund;
		this.hatPartner = user.UserData.Mitgliedschaft.TarifInformation.HatPartner;
		this.beschreibung = user.UserData.Mitgliedschaft.TarifInformation.Beschreibung;
		this.plusMitglied = user.UserData.Mitgliedschaft.PlusMitglied;
		this.premiumMitglied = user.UserData.Mitgliedschaft.PremiumMitglied;
	}


	public mergeWithFamily(familyMembers: MitgliedschaftFamilienverbundApi): void {
		if (familyMembers.Partner) {
			this.geburtsdatumPartner = familyMembers.Partner.Geburtsdatum;
		}
		this.geburtsdatumKinder = [];
		familyMembers.Kinder.forEach((child) => {
			this.geburtsdatumKinder.push(child.Geburtsdatum);
		});
		familyMembers.JungeErwachsene.forEach((child) => {
			this.geburtsdatumKinder.push(child.Geburtsdatum);
		});
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ContractInfo {
		return AppUtils.Helper.createFromMap(dataObject, ContractInfo);
	}

	public static getDescription(mappings: { [key: string]: string }, code: number): string {
		return (mappings || {})[`${  code}`] || "Mitgliedschaft";
	}
}
